module.exports = __webpack_public_path__ + "static/media/page1pic1.51065f69.jpg";